export const parent = (
  orgPath: string,
  page: "login" | "signup",
  method: "email" | "phone",
  searchParams?: URLSearchParams
) => {
  const urlSearchParams = new URLSearchParams();
  searchParams?.forEach((value, key) => {
    urlSearchParams.set(key, value);
  });
  urlSearchParams.set("page", page);
  urlSearchParams.set("method", method);
  return `/${orgPath}?${urlSearchParams.toString()}`;
};

export const admin = (orgPath: string) => {
  const searchParams = new URLSearchParams({
    page: "login",
  });
  return `/${orgPath}/admin?${searchParams.toString()}`;
};
